import React from 'react';
import { SearchNav } from './search_nav';
import {isEmpty} from 'lodash';
import EditionSwitch from './edition_switch';
import { SOCIAL_ICONS } from '../social_icons_new';
import { BeautyconMenuLogo, SomosMenuLogo, UnbotheredMenuLogo } from './vertical_logos';
import classNames from 'classnames';
import { HEADER_LINKS } from "../../constants";
import { sendDataLayerEvent } from '../../utils/analytics';

const SOCIALS = [
    {
        name: 'facebook',
        urls: {
            'default': 'https://www.facebook.com/refinery29/',
            'en-gb': 'https://www.facebook.com/refinery29uk/',
            'en-au': 'https://www.facebook.com/Refinery29Australia/',
            'fr-fr': 'https://www.facebook.com/refinery29uk/'
        } 
    },
    {
        name: 'twitter',
        urls: {
            'default': 'https://x.com/refinery29',
            'en-gb': 'https://x.com/refinery29uk',
            'en-au': 'https://x.com/refinery29au'
        }
    },
    {
        name: 'instagram',
        urls: {
            'default': 'https://www.instagram.com/refinery29/',
            'en-gb': 'https://www.instagram.com/refinery29uk/?hl=en',
            'en-au': 'https://www.instagram.com/refinery29au/?hl=en',
            'fr-fr': 'https://www.instagram.com/refinery29uk/?hl=en'
        }
    },
    {
        name: 'pinterest',
        urls: {
            'default': 'https://www.pinterest.com/refinery29/'
        }
    },
    {
        name: 'snapchat',
        urls: {
            'default': 'https://www.snapchat.com/add/refinery29'
        }
    },
    {
        name: 'youtube',
        urls: {
            'default': 'https://www.youtube.com/refinery29'
        }
    },
    {
        name: 'tiktok',
        urls: {
            'default': 'https://www.tiktok.com/@refinery29',
            'en-au': 'https://www.tiktok.com/@refinery29au?lang=en'
        }
    },
    {
        name: 'email',
        urls: {
            'default': 'https://jump.refinery29.com/join/24/signup-all-newsletters?utm_source=footer&utm_medium=emailsignup&_ga=2.174034529.350230817.1728573652-162356488.1728573652',
            'en-gb': 'https://jump.refinery29.com/join/signup-gb-2020'
        }
    },
];

export class Menu extends React.Component {

    constructor(props) {
        super(props);
    }

    editionSwitch = !isEmpty(this.props.edition_data) &&
        <EditionSwitch edition_data={this.props.edition_data} alternate_urls={this.props.alternate_urls} />;

    editionBaseName = !isEmpty(this.props.edition_data) && this.props.edition_data.basename ? this.props.edition_data.basename : 'en-us';

    handleDataLayerEvent = (event, data, url) => {
        event.preventDefault();
        sendDataLayerEvent('nav_item_click', {data: {navLocation: 'header', navItem: data}}, true, url);
      }

        render() {
        return (<div className={classNames('global-menu', {'menu-open': this.props.menuOpen})}>
        <div className="menu-inner">
            <SearchNav recordSearchTerm={this.props.recordSearchTerm}/>
            <div className="category-children">
                <div className="category-child">
                    <div><a href={HEADER_LINKS[this.editionBaseName].Unbothered} onClick={(e) => this.handleDataLayerEvent(e, 'unbothered', HEADER_LINKS[this.editionBaseName].Unbothered)}>{UnbotheredMenuLogo}</a></div>
                    <p>A community celebrating Black voices, Black art, and Black folx.</p>
                </div>
                <div className="category-child">
                    <div><a href={HEADER_LINKS[this.editionBaseName].Somos} onClick={(e) => this.handleDataLayerEvent(e, 'somos', HEADER_LINKS[this.editionBaseName].Somos)}>{SomosMenuLogo}</a></div>
                    <p>Latines learning, remembering, healing, and finding joy in our diverse stories.</p>
                </div>
                <div className="category-child">
                    <div><a href="https://www.beautycon.com/" onClick={() => this.handleDataLayerEvent(e, 'beautycon', 'https://www.beautycon.com/')}>{BeautyconMenuLogo}</a></div>
                    <p>Beautycon is a global platform that brings together beauty enthusiasts, brands, and industry leaders to explore the latest trends, innovations, and conversations shaping the future of beauty.</p>
                </div>
            </div>
            {this.props.navigationItems.map((item) => {
                return (
                <div key={item.id}>
                    <div className="category-title">{item.display_name}</div>
                    <div className="category-children">{item.children.map((child) => {
                        return (<div className="category-child" key={child.id}><a href={child.path} onClick={(e) => this.handleDataLayerEvent(e, child.display_name.replace('#038;', '').toLowerCase(), child.path)}>{child.display_name.replace('#038;', '')}</a></div>)
                    })}</div>
                </div>);
            })}
            <div>
                <div className="category-title">Get In Touch</div>
                <div className="social-icons">
                    {SOCIALS.map((social) => {
                        return SOCIAL_ICONS[social.name] && 
                        (<a key={social.name}
                            href={social.urls[this.editionBaseName] || social.urls.default}
                            target="_blank"
                            onClick={(e) => this.handleDataLayerEvent(e, social.name, social.urls[this.editionBaseName] || social.urls.default)}
                            >
                            {SOCIAL_ICONS[social.name]}
                        </a>)
                    })}
                </div>
            </div>
        </div>

    </div>)
    }

}

export default Menu;
